module.exports.PASS = 'feedback-pass';
module.exports.FAIL = 'feedback-fail';
module.exports.WARN = 'feedback-warn';
module.exports.NOT_APPLICABLE = 'feedback-not-applicable';